import { Controller, useFormContext, Control } from 'react-hook-form';
import { CustomInput, ICustomInput } from './Custom/CustomInput';

interface IFormInput extends ICustomInput {
  control?: Control<any>;
  isRequired?: boolean;
  isReadOnly?: boolean;
  [x: string]: any;
}

export const FormInput = (props: IFormInput) => {
  const { control, ...restProps } = props;
  const methods = useFormContext();
  const _control = methods?.control || control;

  return _control ? (
    <Controller
      control={_control}
      name={restProps?.name}
      render={(renderProps) => {
        const {
          field,
          fieldState: { error },
        } = renderProps;
        const { ref, ...restFieldProps } = field;

        return <CustomInput {...restProps} {...restFieldProps} error={error} />;
      }}
    />
  ) : (
    <CustomInput {...restProps} />
  );
};
